import { render, staticRenderFns } from "./vAminoAcidScoreReport.vue?vue&type=template&id=545151b9&scoped=true"
import script from "./vAminoAcidScoreReport.vue?vue&type=script&lang=ts"
export * from "./vAminoAcidScoreReport.vue?vue&type=script&lang=ts"
import style0 from "./vAminoAcidScoreReport.vue?vue&type=style&index=0&id=545151b9&prod&lang=css"
import style1 from "./vAminoAcidScoreReport.vue?vue&type=style&index=1&id=545151b9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "545151b9",
  null
  
)

export default component.exports